import React from 'react'
import { rankWith, scopeEndsWith } from '@jsonforms/core'

import ElementWrapper from 'designer/component/display/layout/control/ElementWrapper'
import DragElementWrapper from 'designer/component/system/layout/control/DragElementWrapper'

import CustomGallery from 'designer/component/element/Gallery'

export const GallerySystem = (props) => (
  <DragElementWrapper {...props}>
    <CustomGallery {...props} />
  </DragElementWrapper>
)

export const GalleryDisplay = (props) => (
  <ElementWrapper {...props}>
    <CustomGallery {...props} />
  </ElementWrapper>
)

export const galleryTester = rankWith(1000, scopeEndsWith('gallery'))
